import React, { useCallback, useEffect, useState, useMemo } from "react";

import { useTranslation } from "react-i18next";
import styles from "../LeftNavigation.module.scss";

import { useTeamFetcher } from "../../../../utils/TeamsFetcherHooks";

import Search from "@mui/icons-material/Search";
import SearchTeamsModal from "../../../../components/SearchTeamsModal/SearchTeamsModal";
import { useSelector } from "../../../hooks/useSelector";
import { generatePath, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../utils/Constant";

const SearchTeams = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { addToTeam } = useTeamFetcher();
  const teamsState = useSelector((state) => state.myTeams);
  const myTeams = useMemo(() => {
    return teamsState?.teams;
  }, [teamsState]);

  const { allTeams: allTeamsFromState } = useSelector(
    (state) => state.allTeams
  );

  const [showSearchModal, setShowSearchModal] = useState(false);
  const [allTeams, setAllTeams] = useState([]);

  const onSearchCloseClick = () => {
    setShowSearchModal(false);
  };

  const onClick = useCallback(() => {
    setShowSearchModal(true);
  }, [setShowSearchModal]);

  const onAddToTeam = useCallback(
    async (teamId) => {
      const result = await addToTeam(teamId);
      navigate(generatePath(ROUTES.TEAM_PROJECTS, { teamId }));
      return result;
    },
    [addToTeam, navigate]
  );

  /**
   * Fetching all teams
   * DP: Should be probably on the onclick instead of the link so the list is refreshed every time....
   * DP: Or have the search team dialog search directly on the server
   */

  useEffect(() => {
    const flattenTeams = [];
    for (const team of allTeamsFromState) {
      if (Array.isArray(team.teammates)) {
        for (const teammate of team.teammates) {
          flattenTeams.push({
            teamId: team.id,
            name: team.name,
            email: teammate.email,
            first_name: teammate.first_name,
            last_name: teammate.last_name,
            userId: teammate.id,
          });
        }
      }
    }

    setAllTeams(flattenTeams);
  }, [setAllTeams, allTeamsFromState]);

  return (
    <div className={styles.actionContainer}>
      <SearchTeamsModal
        open={showSearchModal}
        allTeams={allTeams}
        myTeams={myTeams}
        onClickClose={onSearchCloseClick}
        onAddToTeam={onAddToTeam}
      />
      <div className={styles.actionItem} onClick={onClick}>
        <div className={styles.actionIcon}>
          <Search />
        </div>
        <span className={styles.display}>{t("navigation.search_team")}</span>
      </div>
    </div>
  );
};

export default SearchTeams;
